import React from 'react';
import { connect } from 'react-redux';
import { filterByAirlines } from '../../../store/actions/index';

const filterAirlines = (props) => {
    let airlineList = null;

    airlineList =  props.airlines && 
    Object.keys(props.airlines).map((airline, index) => {
        return (
            <li className={`mb-3`} key={index}>
                <label className={`u-lineHeight1 u-cursorPointer u-textColorNormal u-relative u-block`}>
                    <input 
                        type="checkbox" 
                        checked={props.selectedFlights.includes(airline)}
                        name={airline} 
                        value={airline} 
                        className={`mr-2`}
                        onChange={(event) => props.onFilterByAirlines(event)}/>
                        {props.airlines[airline]}
                </label>
            </li>
        )
    });

    return (
        <ul className={`u-height180 u-overflowScrollY u-phone-heightAuto u-maxHeight180`}>
            {airlineList}
        </ul>
    );
}

const mapStateToProps = state => {
    return {
        airlines: state.flights.airlineNames,
        selectedFlights: state.flights.selectedFlights,
        flights: state.flights.dom.oneWayFlightsSingle
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFilterByAirlines: (event) => dispatch(filterByAirlines(event.target))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(filterAirlines);


// WEBPACK FOOTER //
// ./src/components/Filters/FilterAirlines/FilterAirlines.js